import React from "react";
var displayObjectives = function displayObjectives(objectives) {
  return objectives.map(function (objective, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: objective.id,
      className: "row mt-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar avatar-xs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar-title font-size-xs rounded-circle bg-secondary-soft text-secondary"
    }, index + 1))), /*#__PURE__*/React.createElement("div", {
      className: "col p-0"
    }, objective.name));
  });
};
var ObjectivesWithBackGround = function ObjectivesWithBackGround(objectives) {
  return objectives === null || objectives === void 0 ? void 0 : objectives.map(function (objective, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "d-flex align-items-center mt-2 mb-3 px-3 py-3 rounded",
      style: {
        backgroundColor: '#E4EBF6'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "me-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar avatar-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar-title font-size-md rounded-circle bg-secondary"
    }, index + 1))), /*#__PURE__*/React.createElement("div", {
      className: "col p-0 font-size-15"
    }, objective.name));
  });
};
var LearningObjectives = function LearningObjectives(_ref) {
  var items = _ref.items,
    sectionTitle = _ref.sectionTitle,
    withBackground = _ref.withBackground;
  return /*#__PURE__*/React.createElement(React.Fragment, null, withBackground ? /*#__PURE__*/React.createElement(React.Fragment, null, ObjectivesWithBackGround(items)) : /*#__PURE__*/React.createElement("div", {
    className: "px-3 my-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "section-header-title pt-3"
  }, sectionTitle), displayObjectives(items)));
};
LearningObjectives.defaultProps = {
  withBackground: false
};
export default LearningObjectives;